import React, { useMemo, useState } from "react";
import NewDisableProposal from "../newDisableProposal";
import EnableProposal from "../enableProposal";

const DisableEnableProposal = () => {
  const tabs = useMemo(
    () => [
      { key: "DISABLE", label: "Disable", Component: NewDisableProposal },
      { key: "ENABLE", label: "Enable", Component: EnableProposal },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState("DISABLE");

  const activeItem = tabs.find((tab) => tab.key === activeTab) || tabs[0];
  const ActiveComponent = activeItem?.Component;

  const renderTab = (tab) => {
    const isSelected = activeTab === tab.key;

    return (
      <div
        key={tab.key}
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab(tab.key)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            setActiveTab(tab.key);
          }
        }}
        className={`view-count proposal-dashboard__filter-card disable-enable-proposal-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{tab.label}</span>
      </div>
    );
  };

  return (
    <div className="proposal-dashboard disable-enable-proposal-page">
      <div className="proposal-dashboard__header disable-enable-proposal-page__header">
        <h2 className="proposal-dashboard__title">Disable / Enable Proposal</h2>
        <p className="proposal-dashboard__subtitle">
          Bulk upload or individually enable and disable proposals
        </p>
      </div>

      <div className="view-options proposal-dashboard__filters disable-enable-proposal-page__tabs">
        {tabs.map(renderTab)}
      </div>

      <div className="disable-enable-proposal-page__content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default DisableEnableProposal;
